module.exports = __webpack_public_path__ + "img/03.9e07d7d3.png";